import React, { ReactElement } from 'react'
import { ChildrenProp } from '../../jsx'

interface Props extends ChildrenProp {}

export function FilterItemListItemWrapper ({ children }: Props): ReactElement {
  return <div className="filter-item__list-item">{children}</div>
}
